import Head from 'next/head'

import { useCareProvider } from '@providers/providers.hooks'
import { styled } from '@nilohealth/core-ui'

const LayoutWrapper = styled('div', {
  display: 'flex',
  flex: '1',
  overflowY: 'auto',
  width: '100vw',
  flexDirection: 'column',
  backgroundColor: '$neutralHighLight',
  '> div': { justifySelf: 'start' },
  variants: {
    withoutNavbar: {
      false: {
        '@xs': { paddingTop: '$xsmall' },
        '@sm': { paddingTop: '$medium' },
        '@md': { paddingTop: '$medium' },
        '@lg': { paddingTop: '$large' },
        '@xl': { paddingTop: '$large' },
      },
    },
  },
})

type LayoutProps = {
  title?: string
  withoutNavbar?: boolean
  children: React.ReactNode
}
export const Layout = ({ title, withoutNavbar, children }: LayoutProps) => {
  const { careProvider } = useCareProvider()

  const careProviderName = careProvider?.name ?? 'Nilo Saúde'

  const fullTitle = title ? `${careProviderName} - ${title}` : careProviderName

  return (
    <>
      <Head>
        <title>{fullTitle}</title>
      </Head>
      <LayoutWrapper withoutNavbar={!!withoutNavbar}>{children}</LayoutWrapper>
    </>
  )
}
